var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12943_120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.675 6.39903C63.9885 4.99193 62.0099 3.97807 59.8827 3.43105C57.7556 2.88403 55.5333 2.8176 53.3772 3.23657L48.1587 4.51457C45.4354 5.01362 42.9733 6.4518 41.2009 8.5788C39.4285 10.7058 38.458 13.3869 38.4583 16.1556V61.9121C36.4966 62.1991 34.5035 62.1991 32.5417 61.9121V16.1556C32.5515 13.4125 31.6034 10.7519 29.8611 8.63317C28.1188 6.5144 25.6915 5.0703 22.9981 4.55007L17.4542 3.20107C15.3217 2.81085 13.1295 2.89414 11.0327 3.44506C8.93601 3.99598 6.986 5.00105 5.32076 6.38913C3.65551 7.77721 2.31574 9.51436 1.39628 11.4776C0.476819 13.4409 0.000144404 15.5823 0 17.7502L0 49.6794C0.000169974 53.1431 1.21581 56.4968 3.43502 59.1561C5.65423 61.8153 8.73628 63.6115 12.144 64.2315L30.74 67.6129C33.8876 68.1848 37.1124 68.1848 40.26 67.6129L58.8708 64.2315C62.2758 63.6084 65.3544 61.8109 67.5707 59.1519C69.7869 56.493 71.0005 53.1409 71 49.6794V17.7502C71.0014 15.583 70.5249 13.4422 69.6045 11.4802C68.6841 9.51826 67.3424 7.78334 65.675 6.39903Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12943_120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 71,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.06c38f1b14bc6a63495ad6611e4c1039.svg";
export { ForwardRef as ReactComponent };